export interface IOpenAuthModalParameters {
  autoRefresh: boolean;
  alert: null;
  useDefaultView: boolean;
  viewData: object | null;
  source: null;
}

export async function openAuthModal(parameters: IOpenAuthModalParameters): Promise<void> {
  const { registry } = await import('@cian/mf-registry/browser');
  const microfrontend = registry().microfrontendStrict('header-frontend');
  const api = microfrontend.api();

  if (!api) {
    return;
  }

  await api.ensure();
  await api.call('/v3/open-auth-modal/', parameters);
}
